import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-feature-icon-encounter-prevention',
	templateUrl: './feature-icon-encounter-prevention.component.svg',
})
export class FeatureIconEncounterPreventionComponent {}
